import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { radioIconStyle, radiomarkStyle } from './styles';
function Radiomark({ checked, disabled, error, isFocusVisible, }) {
    return (_jsx("div", Object.assign({ css: radiomarkStyle({
            disabled,
            hasError: error,
            isFocusVisible,
        }) }, { children: checked && _jsx("span", { css: radioIconStyle({ disabled }) }) })));
}
export default Radiomark;
